var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auro-releases"},_vm._l((_vm.data.rows),function(document){return _c('auro-release',{key:document.id,staticClass:"auro-releases__item",attrs:{"data":document,"actionsMeta":_vm.actionsMeta}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }